import { Injectable } from '@angular/core';

import { AlertConfig } from '../models/AlertsNotificationConfig';

@Injectable()
export class AlertsNotificationConfigService {
    updateAlertConfig(alertsConfig: AlertConfig[], alertConfigName: string, isActive: boolean): AlertConfig[] {
        return alertsConfig.map((alertConfig) =>
            alertConfig.name === alertConfigName ? { ...alertConfig, isActive: isActive } : alertConfig,
        );
    }
}
